module.exports = __webpack_public_path__ + "img/profile-picture-nathalie-min.5de8b965.png";